import React from 'react'

export default function FourOhFour(props) {
    return <div className="controller"><div className="tpBlackBg">
        <h2>We're Sorry</h2>
        <h1>ERROR: 404 Page Not Found</h1>
        <p>Error Code DEFAULTCOMP</p>
    </div></div>
}